// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// sudo-switch-user imports
import { IContainer, IProps, IState } from "./SudoDeactivateUser.d";
import { sudoDeactivateUserFragments } from "./SudoDeactivateUser.gql";
import { styles } from "./SudoDeactivateUser.styles";
import { styles as sudoStyles } from "@components/sudo-wrapper/SudoWrapper.styles";

// state
import { IReduxState } from "@reducers/root.reducer";

// util
import { sudoDeactivateUser } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";

// material-ui
import { Button, LinearProgress, Paper, TextField } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class SudoDeactivateUserCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
      email: "",
    };
  }

  public handleEmailChange = (e: any) => {
    this.setState({
      email: e.target.value,
    });
  };

  private onClick = () => {
    const email = this.state.email.trim();
    if (!email) {
      return;
    }

    const CONFIRMATION_CODE = "DEACTIVATE";
    const confirmationText = window.prompt(`Please confirm by typing ${CONFIRMATION_CODE}`, "");
    if (confirmationText !== CONFIRMATION_CODE) {
      return;
    }

    this.setState({ loading: true });

    sudoDeactivateUser(
      this.props.relay.environment,
      { email },
      () => this.onDeactivateSuccess(),
      () => this.onDeactivateFailure(),
    );
  };

  private onDeactivateSuccess = () => {
    this.setState({ loading: false });
    this.showMessage(`Success, deactivated: ${this.state.email}`);
  };

  private onDeactivateFailure = () => {
    this.setState({ loading: false });
    this.showMessage(`Failed to deactivate user.`);
  };

  private showMessage(message: string) {
    this.props.snackBarOpen(message);
  }

  public render() {
    return (
      <Paper elevation={2} style={sudoStyles.paper}>
        <div style={sudoStyles.title}>Deactivate User</div>
        <div style={sudoStyles.row}>
          <TextField
            label="Email Address"
            onChange={this.handleEmailChange}
            value={this.state.email}
          />
        </div>
        <div style={sudoStyles.row}>
          <Button
            variant="contained"
            color="primary"
            style={sudoStyles.btn}
            onClick={() => this.onClick()}
            disabled={this.state.loading}
          >
            Deactivate User
          </Button>
        </div>
        {this.state.loading ? <LinearProgress variant="indeterminate" /> : null}
      </Paper>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const SudoDeactivateUserStyled = withStyles(styles)(SudoDeactivateUserCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SudoDeactivateUserRedux = connect(mapStateToProps, {
  snackBarOpen,
})(SudoDeactivateUserStyled);

///////////
// Relay //
///////////
export const SudoDeactivateUser = createFragmentContainer<IContainer>(
  SudoDeactivateUserRedux,
  sudoDeactivateUserFragments,
);
